import axios from "axios";

/**
 * @returns 디버깅모드인지
 */
export function isDebug() {
  if (process.env.REACT_APP_BUILD === "debug") {
    return true;
  } else {
    return false;
  }
}

export function getBaseUrl(release = false) {
  if (isDebug()) {
    return release
      ? process.env.REACT_APP_RELEASE_BASE_URL
      : process.env.REACT_APP_DEBUG_BASE_URL;
  } else {
    return process.env.REACT_APP_BASE_URL;
  }
}

export function getFirstDayOfMonth() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1);
}

export function enterToFocusMove(event) {
  if (event.key === "Enter") {
    event.preventDefault();
    const focusableElements = document.querySelectorAll("input, textarea");

    const activeElement = document.activeElement;

    const currentIndex = Array.prototype.indexOf.call(
      focusableElements,
      activeElement
    );

    let nextElement;

    if (event.shiftKey) {
      nextElement = focusableElements[currentIndex - 1] || focusableElements[0];
    } else {
      nextElement = focusableElements[currentIndex + 1] || focusableElements[0];
    }

    nextElement.focus();
  }
}

export function formatNumber(value, format) {
  if (value === null || value === undefined) return "";
  const [integerFormat, decimalFormat] = format.split(".");
  const decimalPlaces = decimalFormat ? decimalFormat.length : 0;

  let valueString = value.toFixed(decimalPlaces);

  let [integerPart, decimalPart] = valueString.split(".");

  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  if (decimalFormat && decimalFormat.includes("#")) {
    decimalPart = decimalPart.replace(/0+$/, "");
    if (decimalPart === "") {
      decimalPart = "0";
    }
  }

  let result = integerPart;
  if (decimalPart !== undefined) {
    result += "." + decimalPart.padStart(decimalPlaces, "0");
  }
  return result;
}

export function isOutsider() {
  return window.sessionStorage.getItem("workplace_cd") !== "DM005";
}

export function setMonitoring(id, menu, job) {
  console.log("2");
  axios.get(getBaseUrl() + "Monitoring", {
    params: {
      id: id,
      menu: menu,
      job: job,
    },
  });
}
